/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React, { useEffect } from "react";
import PropTypes from "prop-types";
import "normalize.css";
import "../styles/font.css";
// import { useStaticQuery, graphql } from 'gatsby';
import { createGlobalStyle, ThemeProvider } from "styled-components";
import { useSpring, animated } from "react-spring";
import styled from "styled-components";

import Header from "./header";
import Footer from "./footer";

const GlobalStyle = createGlobalStyle`
  html {
    box-sizing: border-box;
    background-color: #e7e7e7;
    position: relative;
    min-height: 100%;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }
  //
  body {
    //position: relative;
    min-height: 100%;
    font-family: "Apercu",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif;
    line-height: 1.5;
    font-size: 87.5%;
  //  color: #333;
  //  background-color: #fff;
  }
  h1, h2, h3, h4, h5, h6 {
      font-family: "Silk Serif",Georgia,serif;
      font-weight: normal;
  }
  a {
    color: #333;
    text-decoration: underline;
    
    @media screen and (min-width: 900px) {
      text-decoration: none;
    }
    &:hover {
      opacity: 0.7;
      text-decoration: underline;
    }
  }
  p {
    margin: 1rem 0 0;

    &:first-child {
      margin-top: 0;
    }
  }
`;

const theme = {
  htmlBackgroundColor: "#e7e7e7",
  bodyBackgroundColor: "#fff",
  backgroundColor1: "#f1f1f1",
  backgroundColor2: "#e1d7c9",
  bodySecondaryColor: "#bca273",
  bodyColor: "#333",
  bodyFont:
    '"Apercu",-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,Oxygen-Sans,Ubuntu,Cantarell,"Helvetica Neue",sans-serif',
  headingFont: '"Silk Serif",Georgia,serif',
  footerHeight: "6rem",
  headerHeight: "4rem",
};

const BodyContainer = styled.div`
  background-color: ${(props) => props.theme.bodyBackgroundColor};
  max-width: 1500px;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: ${(props) => props.theme.footerHeight};
  position: relative;
  z-index: 1000;
`;

// const PageContainer = style={pageFadeProps}

const Main = styled.main`
  //overflow: auto;
  letter-spacing: ${(props) => (props.isChinese ? "1px" : "inherit")};
`;

const Layout = ({
  children,
  pageContext,
  uri,
  isIndex = false,
  headerData,
  footerData,
}) => {
  const bodyFadeInProps = useSpring({
    to: { opacity: 1 },
    from: { opacity: 0 },
    delay: 250,
    config: { duration: 250 },
  });

  let { lang } = pageContext;
  if (!lang) {
    lang = "en-gb";
  }

  useEffect(() => {
    if (typeof window === "undefined") {
      return;
    }

    const resizeListener = () => {
      let vh = window.document.documentElement.clientHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty("--vh", `${vh}px`);
    };
    // set resize listener
    resizeListener();
    window.addEventListener("resize", resizeListener);
    // clean up function
    return () => {
      // remove resize listener
      window.removeEventListener("resize", resizeListener);
    };
  });

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <animated.div style={bodyFadeInProps}>
        <BodyContainer>
          <Header
            pageContext={pageContext}
            uri={uri}
            isIndex={isIndex}
            headerData={headerData}
          />
          <Main isChinese={lang === "zh-hk" || lang === "zh-cn" ? 1 : 0}>
            {children}
          </Main>
        </BodyContainer>
        <Footer footerData={footerData} />
      </animated.div>
    </ThemeProvider>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
